(function () {
    "use strict";

    function uploadDialogController($scope, $interval, documentsService) {

        var vm = this;

        vm.files = [];
        $scope.Math = window.Math;

        /**
         * Controller initialization function
         */
        vm.$onInit = function() {
            //documentsService.cleanNonActiveUploads();
            checkUploadingFiles();
        };

        /**
         * On binding changes
         * @param {type} changesObj objetos modificados: { currentValue, previousValue, isFirstChange() }. 
         */
        vm.$onChanges = function () {
            checkUploadingFiles();
        };

        ////Thats not good, but it's the only way to work correctly
        $scope.$on('solpheo_nueva_download', function () {
            console.log('Evento solpheo_nueva_download');
            checkUploadingFiles();
            vm.closingPeriods = 0;
        });

        /**
         * Event when user clicks close button
         */
        vm.onClose = function () {
            documentsService.cleanNonActiveUploads();
            vm.userClose = true;
            vm.show = false;
        };

        function checkUploadingFiles() {
            vm.files = documentsService.uploadingFiles;

            //Hide upload dialog if we have nothing to show
            if (vm.files.length > 0) {
                vm.show = true;
            } else {
                vm.show = false;
            }
        }
        
        //var closeTimeout = $timeout(function () {
        //    vm.show = false;
        //}, 10000);

        //$timeout.cancel(closeTimeout);

        vm.closingPeriods = 0;
        var closeInterval = $interval(function () {
            var allFinished = true;
            if(vm.files && vm.files.length) {
                for (var i = 0; i < vm.files.length; i++) {
                    if (!vm.files[i].inError && !vm.files[i].uploadOk) {
                        allFinished = false;
                        break;
                    }
                }
            }

            if (allFinished) {
                vm.closingPeriods += 1;
            } else {
                vm.closingPeriods = 0;
            }

            if (vm.closingPeriods >= 10) {
                vm.show = false;
                vm.closingPeriods = 0;
                documentsService.cleanNonActiveUploads();
            }
        }, 1000);

        $scope.$on('$destroy', function () {
            if (closeInterval) {
                $interval.cancel(closeInterval);
            }
        });
    }


    uploadDialogController.$inject = ['$scope', '$interval', 'solpheo.documentsService'];

    angular.module('solpheo')
    .component('solpheoUploadDialogComponent', {
        templateUrl: 'modules/documents/components/upload/documents.uploadDialog.template.html',
        controller: uploadDialogController,
        bindings: {
        //    files: '<',
            errFiles: '<'
        //    //, show: '<'
        //    , checkCondition: '<'
        }
    });

}());